import { FunctionComponent, useCallback, useEffect, useState } from 'react';

interface ImgProps {
  urls: string[];
  alt: string;
}

const Img: FunctionComponent<ImgProps> = ({ urls, alt }) => {
  const [listAlternatives, setListAlternatives] = useState<string[]>([]);

  useEffect(() => {
    setListAlternatives(urls.filter(Boolean));
  }, [urls]);

  const [firstAlternative] = listAlternatives;

  const onError = useCallback(() => {
    setListAlternatives((current) => current.slice(1));
  }, []);

  if (!firstAlternative) {
    return null;
  }

  return <img alt={alt} src={firstAlternative} onError={onError} />;
};

export default Img;
